import Splide from '@splidejs/splide';
import elmntIO from './inc/elmnt-io';

export function mapSlider() {
    const $comp = document.querySelector('.component--map-slider');
    if ( !$comp ) return;
    const $slider = $comp.querySelector('.splide--map-slider');
    const $mapSliderBgItems = $comp.querySelectorAll('.map-slider__bg-item');
    const $mapWrap = document.getElementById('map-slider-map');
    if ( !$slider ) return;

    const desktopMq = window.matchMedia('(min-width: 1190px)');
    const mapClassesObj = {
        towns: 'towns-active',
        parks: 'parks-active',
        'game-lands': 'game-lands-active',
    }

    let splide = null;
    let syncingFromScroll = false;
    let scrollingToBg = false;
    let bgScrollToken = 0;

    elmntIO($comp, null, handleCompExit);

    $mapSliderBgItems?.forEach($bgItem => {
        elmntIO($bgItem, handleBgEnter);
    });

    syncDesktopMode();
    desktopMq.addEventListener('change', syncDesktopMode);


    function syncDesktopMode() {
        if ( desktopMq.matches ) {
            mountSlider();
        } else {
            destroySlider();
        }
    }

    function mountSlider() {
        if ( splide ) return;

        splide = new Splide($slider, {
            type: 'slide',
            direction: 'ttb', // top to bottom
            height: 650,
            gap: '1rem',
            perPage: 1,
            speed: 800,
            pagination: true,
            arrows: true,
            breakpoints: {
                599: {
                    height: 330,
                },
                1199: {
                    height: 300,
                }
            },
        });

        splide.on('move', (newIndex) => {
            if ( !desktopMq.matches ) return;
            setMapLayer(newIndex);
            if ( syncingFromScroll ) return;
            scrollBgToTop(newIndex);
        });

        splide.mount();
        syncToVisibleBg();
    }

    function destroySlider() {
        if ( !splide ) return;

        splide.destroy();
        splide = null;
        scrollingToBg = false;
        syncingFromScroll = false;
        $mapWrap?.classList.remove(...Object.values(mapClassesObj));
    }

    function syncToVisibleBg() {
        if ( !splide || !$mapSliderBgItems.length ) return;

        let bestIndex = 0;
        let bestDist = Infinity;
        $mapSliderBgItems.forEach(($bgItem, i) => {
            const rect = $bgItem.getBoundingClientRect();
            const dist = Math.abs((rect.top + rect.height / 2) - (window.innerHeight / 2));
            if ( dist < bestDist ) {
                bestDist = dist;
                bestIndex = i;
            }
        });

        syncingFromScroll = true;
        splide.go(bestIndex);
        syncingFromScroll = false;
        setMapLayer(bestIndex);
    }


    // ========== comp ==========
    function handleCompExit(entry) {
        if ( !desktopMq.matches ) return;
        $mapWrap?.classList.remove(...Object.values(mapClassesObj));
    }


    // ========== bg items ==========
    function handleBgEnter(entry) {
        if ( !desktopMq.matches || !splide ) return;
        if ( scrollingToBg ) return;

        const $thisItem = entry.target;
        const slideIndex = Number($thisItem.dataset.index) - 1;

        syncingFromScroll = true;
        splide.go(slideIndex);
        syncingFromScroll = false;

        setMapLayer(slideIndex);
    }

    function setMapLayer(index) {
        const $bgItem = $mapSliderBgItems[index];
        if ( !$bgItem || !$mapWrap ) return;

        const mapLayer = $bgItem.dataset.mapLayer;
        $mapWrap.classList.remove(...Object.values(mapClassesObj));
        if ( mapClassesObj[mapLayer] ) {
            $mapWrap.classList.add(mapClassesObj[mapLayer]);
        }
    }

    function scrollBgToTop(index) {
        const $bgItem = $mapSliderBgItems[index];
        if ( !$bgItem ) return;
        if ( Math.abs($bgItem.getBoundingClientRect().top) < 1 ) return;

        const token = ++bgScrollToken;
        scrollingToBg = true;
        const unlock = () => {
            if ( token !== bgScrollToken ) return;
            scrollingToBg = false;
        };
        window.addEventListener('scrollend', unlock, { once: true });
        window.setTimeout(unlock, 2000);

        window.scrollTo({
            top: $bgItem.getBoundingClientRect().top + window.scrollY,
            behavior: 'smooth',
        });
    }
}
